import { Card } from '@rewind-ui/core'
import React, { useState } from 'react'
import { TbCircleArrowRightFilled } from 'react-icons/tb'
import { Button } from 'flowbite-react'
import { RiArrowLeftCircleLine } from 'react-icons/ri'

const IntroCard = ({ switchToLogin, switchToRegisterUser, switchToRegisterBiz }) => {
    const [user, setUserState] = useState(null)
    const [loading, setLoading] = useState(false)
    const hasSelected = user !== null

    // Continue handler: call the correct registration function
    const handleContinue = () => {
        if (!user) return
        if (user === 'Idea') {
            switchToRegisterUser()
        } else {
            switchToRegisterBiz()
        }
    }

    return (
        <div className="flex flex-col items-center justify-center min-h-[60vh] py-2 bg-gray-50">
            <button onClick={switchToLogin} className='mb-2 self-center text-gray-400 hover:text-blue-500 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-200 rounded-full'>
                <RiArrowLeftCircleLine size={28} />
            </button>
            <Card size='lg' className='flex flex-col border bg-white rounded-2xl shadow-lg p-4 sm:p-6 md:p-8 w-full max-w-md'>
                <div className='flex flex-col items-center gap-8'>
                    <h2 className='text-2xl font-bold text-gray-800 mb-2 text-center'>Select Account Type</h2>
                    <div className='flex w-full gap-4'>
                        <button
                            onClick={() => setUserState('Idea')}
                            className={`flex-1 flex flex-col items-center justify-center py-6 rounded-xl border-2 transition-all duration-200 text-lg font-medium shadow-sm ${
                                user === 'Idea'
                                    ? 'bg-green-500 border-green-600 text-white scale-105 shadow-md'
                                    : 'bg-white border-gray-200 text-gray-700 hover:bg-gray-100'
                            }`}
                        >
                            <span className="text-3xl mb-2">💡</span>
                            Idea
                        </button>
                        <button
                            onClick={() => setUserState('Business')}
                            className={`flex-1 flex flex-col items-center justify-center py-6 rounded-xl border-2 transition-all duration-200 text-lg font-medium shadow-sm ${
                                user === 'Business'
                                    ? 'bg-green-500 border-green-600 text-white scale-105 shadow-md'
                                    : 'bg-white border-gray-200 text-gray-700 hover:bg-gray-100'
                            }`}
                        >
                            <span className="text-3xl mb-2">🏢</span>
                            Business
                        </button>
                    </div>
                    <Button
                        onClick={handleContinue}
                        pill
                        color='success'
                        disabled={!hasSelected || loading}
                        className='w-full mt-4 text-lg font-semibold flex items-center justify-center gap-2 py-3'
                    >
                        Continue
                        <TbCircleArrowRightFilled className='text-xl ms-2' />
                    </Button>
                </div>
            </Card>
        </div>
    )
}

export default IntroCard